module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dan_contents"
    }
  }, [_vm._v("SELECT BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Albright, W. F. (1921), ‘The Date and Personality of the Chronicler’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL ")]), _vm._v("40(3): 104–124.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Allison, D. C., Jr (2014), ‘Apocalyptic Ethics and Behavior’, in J. J. Collins (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Oxford Handbook of Apocalyptic Literature")]), _vm._v(" (Oxford: Oxford University Press), pp. 295–311.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Anderson, B. W. (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Contours of Old Testament Theology")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Anderson, R. A. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Signs and Wonders: A Commentary on the Book of Daniel")]), _vm._v(", ITC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Archer, G. L., Jr (1985), ‘Daniel’, in F. E. Gaebelein (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EBC")]), _vm._v(" 7 (Grand Rapids: Zondervan), 7: 3–157.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Astin, A. E. et al. (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cambridge Ancient History: Volume VIII, Rome and the Mediterranean to 133 B.C.")]), _vm._v(", 2nd edn (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Averbeck, R. E. (1997), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("g’l")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE")]), _vm._v(" 1: 794–795.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Baldwin, J. G. (1978), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel: An Introduction and Commentary")]), _vm._v(", TOTC (Leicester: Inter-Varsity Press; Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Bartholomew, C. G. and M. W. Goheen (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Drama of Scripture: Finding Our Place in the Biblical Story")]), _vm._v(" (Grand Rapids: Baker)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Bengtson, H. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Greece: From the Beginnings to the Byzantine Era")]), _vm._v(", 4th edn, trans. and updated by Edmund F. Bloedow (Ottawa: University of Ottawa Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Berry, W. (1981), ‘Discipline and Hope’, in W. Berry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recollected Essays: 1965–1980 ")]), _vm._v("(San Francisco: North Point Press), pp. 151–220.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Life Is a Miracle: An Essay against Modern Superstition ")]), _vm._v("(Berkeley, CA: Counterpoint).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2006), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Way of Ignorance and Other Essays")]), _vm._v(" (Berkeley, CA: Counterpoint).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2013), ‘Amish Economy’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sabbaths")]), _vm._v(" (Berkeley, CA: Counterpoint), pp. 160–161.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This New Day: Collected Sabbath Poems, 1979–2013")]), _vm._v(" (Berkeley, CA: Counterpoint).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Bevan, A. A. (1892), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Short Commentary on the Book of Daniel: For the Use of Students ")]), _vm._v("(Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Booth, W. C. (1961), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rhetoric of Fiction ")]), _vm._v("(Chicago: University of Chicago Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Breed, B. (April 2017), ‘Daniel’s Four Kingdoms Schema: A History of Re-writing World History’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Int ")]), _vm._v("71(2): 178–189.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Briant, P. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From Cyrus to Alexander: A History of the Persian Empire")]), _vm._v(", trans. P. T. Daniels (Winona Lake: Eisenbrauns).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Brueggemann, W. (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Out of Babylon")]), _vm._v(" (Nashville: Abingdon Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Casey, M. (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Son of Man: The Interpretation and Influence of Daniel 7 ")]), _vm._v("(London: SPCK).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2007), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Solution to the ‘Son of Man’ Problem")]), _vm._v(", LNTS (London: T. & T. Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Charles, R. H. (1929), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Critical and Exegetical Commentary on the Book of Daniel ")]), _vm._v("(Oxford: Clarendon Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Childs, B. S. (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction to the Old Testament as Scripture")]), _vm._v(" (Philadelphia: Fortress Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (1985), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Testament Theology in a Canonical Context ")]), _vm._v("(Philadelphia: Fortress Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Collins, J. J. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel: With an Introduction to Apocalyptic Literature")]), _vm._v(", FOTL 20 (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (1993), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", Hermeneia (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Apocalyptic Imagination: An Introduction to the Jewish Apocalyptic Literature")]), _vm._v(", 3rd edn (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("de Miroschedji, P. (1992), ‘Susa’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ABD ")]), _vm._v("6.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Dillard, R. B. and T. Longman III (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Introduction to the Old Testament")]), _vm._v(" (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Dougherty, R. P. (1929), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nabonidus and Belshazzar: A Study of the Closing Events of the Neo-Babylonian Empire")]), _vm._v(", Yale Oriental Series 15 (New Haven: Yale University Press)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Driver, S. R. (1900), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Daniel")]), _vm._v(", Cambridge Bible for Schools and Colleges (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Drury, J. (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music at Midnight: The Life and Poetry of George Herbert ")]), _vm._v("(Chicago: University of Chicago Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Ferguson, S. B. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Communicator’s Commentary: Daniel")]), _vm._v(" (Waco: Word Books).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Fewell, D. N. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Circle of Sovereignty: A Story of Stories in Daniel 1–6")]), _vm._v(", JSOTSup 72/BLS 20 (Sheffield: Sheffield Academic Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Goldingay, J. (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", WBC 30 (Dallas: Word).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Goldsworthy, G. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("According to Plan: The Unfolding Revelation of God in the Bible ")]), _vm._v("(Leicester: Inter-Varsity Press; Downers Grove: InterVarsity Press)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Gowan, D. E. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", AbOTC (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hafemann, S. J. and P. R. House (eds.) (2007), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Central Themes in Biblical Theology: Mapping Unity in Diversity")]), _vm._v(" (Nottingham: Apollos; Grand Rapids: Baker)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hanson, P. D. (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Dawn of Apocalyptic: The Historical and Sociological Roots of Jewish Apocalyptic Eschatology")]), _vm._v(", rev. edn (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hartman, L. F. and A. A. Di Lella (1977), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Daniel")]), _vm._v(", AB 23 (Garden City: Doubleday).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (1978), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Daniel")]), _vm._v(", AB 23"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Garden City: Doubleday).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hasel, G. F. (1977), ‘The First and Third Years of Belshazzar (Daniel 7:1; 8:1)’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("AUSS")]), _vm._v(" 15(2): 153–168.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Havel, V. (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Disturbing the Peace")]), _vm._v(" (London: Faber & Faber).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Heaney, S. (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Redress of Poetry")]), _vm._v(" (London: Faber & Faber).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hölbl, G. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A History of the Ptolemaic Empire")]), _vm._v(", trans. Tina Saavedra (London: Routledge).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Holm, T. L. (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Of Courtiers and Kings: The Biblical Daniel Narratives and Ancient Story-Collections")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EANEC")]), _vm._v(" 1 (Winona Lake: Eisenbrauns)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("House, P. R. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zephaniah – A Prophetic Drama")]), _vm._v(", JSOTSup 16 (Sheffield: Sheffield Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Unity of the Twelve")]), _vm._v(", JSOTSup 27 (Sheffield: Sheffield Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (1998), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Testament Theology")]), _vm._v(" (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (Spring 2005), ‘God’s Character and the Wholeness of Scripture’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scottish Bulletin of Evangelical Theology ")]), _vm._v("23(1): 4–17."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Humphreys, W. L. (1973), ‘A Lifestyle for Diaspora: A Study of the Tales of Esther and Daniel’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL ")]), _vm._v("92: 211–223.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Jenson, P. P. (1997), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("swr")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE")]), _vm._v(", 3: 790–791.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Jerome (1958), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerome’s")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Daniel")]), _vm._v(", trans. Gleason L. Archer, Jr"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(orig. 407; Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Johnson, I. (2013), ‘China Embarking on Vast Program of Urbanization’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New York Times")]), _vm._v(", June 16, A1.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Johnston, P. S. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shades of Sheol: Death and Afterlife in the Old Testament ")]), _vm._v("(Leicester: Apollos; Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Jones, G. H. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1 and 2 Kings, Volume II")]), _vm._v(", NCBC"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kaiser, W. C., Jr (1978), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toward an Old Testament Theology")]), _vm._v(" (Grand Rapids: Zondervan, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Keil, C. F. (1980), ‘Daniel’, in C. F. Keil and F. Delitzsch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the Old Testament")]), _vm._v(", trans. M. G. Easton (orig. 1869; Grand Rapids: Eerdmans), 9: 115.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kitchen, K. A. (1965), ‘The Aramaic of Daniel’, in D. J. Wiseman et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes on Some Problems in the Book of Daniel")]), _vm._v(" (London: Tyndale), pp. 31–79.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Reliability of the Old Testament")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Koch, K. (1972), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rediscovery of Apocalyptic")]), _vm._v(", trans. M. Kohl"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Nashville: Allenson).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("LaCocque, A. (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Daniel")]), _vm._v(", trans. D. Pellauer (Atlanta: John Knox Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Lederach, P. M. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", Believers Church Bible Commentary (Sacramento: Herald Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Lewis, D. M. et al. (eds.) (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cambridge Ancient History: Volume VI, The Fourth Century B.C.")]), _vm._v(", 2nd edn (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Longman, T., III (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Lucas, E. C. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", AOTC (Leicester: Apollos; Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Lundbom, J. R. (April 2017), ‘Builders of Ancient Babylon: Nabopolassar and Nebuchadnezzar II’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")]), _vm._v(" 71(3): 154–166.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Maclean, N. (1976), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A River Runs through It and Other Stories")]), _vm._v(" (Chicago: University of Chicago Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("McComiskey, T. E. (1985), ‘The Seventy “Weeks” of Daniel against the Background of Ancient Near Eastern Literature’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("WTJ")]), _vm._v(" 47: 18–45.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("McCullough, C. T. (2008), ‘Introduction to Daniel’, in K. Stevenson and M. Glerup (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ezekiel, Daniel")]), _vm._v(", Ancient Christian Commentary on Scripture 13, ed. Thomas Oden (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Martens, E. A. (1981), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s Design: A Focus on Old Testament Theology")]), _vm._v(" (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Millard, A. R. (1977), ‘Daniel 1–6 and History’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ ")]), _vm._v("49(2): 67–73.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Miller, S. R. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", NAC 18 (Nashville: Broadman & Holman).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Montgomery, J. A. (1927), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Critical and Exegetical Commentary on the Book of Daniel")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("ICC (New York: Charles Scribner’s Sons).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Murphy, F. J. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apocalypticism in the Bible and Its World")]), _vm._v(" (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Newsom, C. A. and B. W. Breed (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", OTL (Louisville: Westminster John Knox Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Olmstead, A. T. (1948), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Persian Empire: Achaemenid Period")]), _vm._v(" (Chicago: University of Chicago Press)."), _c('span', {
    staticClass: "bold"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Owens, J. J. (1971), ‘Daniel’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Broadman Bible Commentary, Volume 6: Jeremiah–Daniel")]), _vm._v(", ed. Clifton J. Allen (Nashville: Broadman Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Porteous, N. (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", rev. edn, OTL (London: SCM).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Redditt, P. L. (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", NCBC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Rendtorff, R. (1998), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Covenant Formula: An Exegetical and Theological Investigation")]), _vm._v(" (London: T. & T. Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("___ (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Canonical Hebrew Bible: A Theology of the Old Testament")]), _vm._v(", trans. D. E. Orton, Tools for Biblical Study (Leiden: Deo).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Rowley, H. H. (1950), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Relevance of Apocalyptic")]), _vm._v(", 2nd edn (London: Lutterworth Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Russell, D. S. (1964), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Method and Message of Jewish Apocalyptic, 200 BC – AD 100")]), _vm._v(", OTL (Philadelphia: Westminster John Knox Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Ryken, L. et al. (1998), ‘Heavenly Armies/Hosts’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary of Biblical Imagery")]), _vm._v(" (Downers Grove: InterVarsity Press), pp. 372–373.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Scheetz, J. M. (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Daniel as a Text in Theological Hermeneutics")]), _vm._v(" (Cambridge: James Clarke).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Schürer, E. (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A History of the Jewish People in the Time of Christ: Vol. I")]), _vm._v(", trans. John Macpherson et al. (orig. 1890; Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Seow, C. L. (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", Westminster Bible Companion (Louisville: Westminster John Knox Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Steiner, G. (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Real Presences ")]), _vm._v("(Chicago: University of Chicago Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Steinmann, A. E. (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", ConC (Saint Louis: Concordia)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Sternberg, M. (1985), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Poetics of Biblical Narrative: Ideological Literature and the Drama of Reading")]), _vm._v(" (Bloomington: Indiana University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Stevenson, K. and M. Glerup (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ezekiel, Daniel")]), _vm._v(", Ancient Christian Commentary on Scripture 13, ed. Thomas Oden (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Thiel, W. (2003), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sûr")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TDOT")]), _vm._v(", 12: 306–311.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Towner, W. S. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel")]), _vm._v(", IBC (Atlanta: John Knox Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Vallat, F. (1992), ‘Elam’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ABD ")]), _vm._v("2.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Vanderhooft, D. S. (2000), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Neo-Babylonian Empire and Babylon in the Latter Prophets")]), _vm._v(", HSM 59 (Atlanta: Scholars Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Vogel, W. (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cultic Motif in the Book of Daniel")]), _vm._v(" (New York: Peter Lang).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Vogt, E. (ed.) (2011), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Lexicon of Biblical Aramaic: Clarified by Ancient Documents")]), _vm._v(", trans. and rev. J. A. Fitzmyer (Rome: Gregorian and Biblical Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("von Rad, G. (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Testament Theology, Volume Two: The Theology of Israel’s Prophetic Traditions")]), _vm._v(", trans. D. M. G. Stalker (New York: Harper & Row)."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wills, L. M. (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Jew in the Court of the Foreign King")]), _vm._v(", HDR (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wiseman, D. J. (1985), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nebuchadrezzar and Babylon")]), _vm._v(" (Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wiseman, D. J. et al. (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes on Some Problems in the Book of Daniel")]), _vm._v(" (London: Tyndale Press).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Yamauchi, E. M. (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Persia and the Bible ")]), _vm._v("(Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Yamauchi, E. M. and M. R. Wilson (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary of Daily Life in Biblical and Post-Biblical Antiquity: Vol. III, I–N ")]), _vm._v("(Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Young, E. J. (1949), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Prophecy of Daniel: A Commentary ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "fo_rleft"
  }), _vm._v(" "), _c('p', {
    staticClass: "fo_rleft"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99d9e436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dan_Biblio.vue
// module id = 75
// module chunks = 0